





















import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class TradeSideBar extends Vue {
  
  public countProjectItem:number = null;
  public countOrder:number = null;
  public countDelivery:number= null;
  public countCharge:number= null;
  public countAloneInvoice:number= null;
  public countCarryOverInvoice:number= null;

  public created() {
    this.$api.addEventListener('workflow',this.reload);
  }
  public destroyed() {
    this.$api.removeEventListener('workflow',this.reload);
  }
  public mounted(){
    this.reload();
  }
  public reload(){    
    this.$api.execute(new Common.TaskCountQuery('SalesTaskCountQuery', false)).then(res =>{
      var hash = res as { [key: string]: number};
      this.countProjectItem = hash.ProjectItem;
      this.countOrder = hash.SalesOrder;
      this.countDelivery = hash.SalesDelivery;
      this.countCharge = hash.SalesCharge;
      this.countAloneInvoice = hash.AloneInvoice;
      this.countCarryOverInvoice = hash.CarryOverInvoice;
    });
  }
}
